import { useParams } from 'react-router';
import { fetchPrispevokVestnikaDetail } from '../../../client/prispevokVestnikaDetailClient';
import { ClientStatus } from '../../../model/types/ClientStatus';
import { useClientFetch } from '../../../context/ClientStatusContext';
import PrispevokVestnika from '../../../model/PrispevokVestnika';

interface ReturnType {
  prispevokVestnikaDetail: PrispevokVestnika;
  prispevokVestnikaStatus: ClientStatus;
  reloadPrispevokVestnikaDetail
}

export default (): ReturnType => {
  const { uuid } = useParams<{ uuid: string }>();
  const {
    data: prispevokVestnikaDetail,
    status: prispevokVestnikaStatus,
    refetch: reloadPrispevokVestnikaDetail,
  } = useClientFetch(
    fetchPrispevokVestnikaDetail,
    [uuid],
    [uuid],
  );
  return {
    prispevokVestnikaDetail,
    prispevokVestnikaStatus,
    reloadPrispevokVestnikaDetail,
  };
};
